var lib_core = require("lib-core");
var ui_templates = require("ui-templates");
var cio_datamodel = require("cio-datamodel");

var ExportModelView = function(model, stateMachine, root, masterModel, button) {
    var self = this;

    this.model = model;
    this.stateMachine = stateMachine;

    this.exportModal = null;
    this.versionModal = null;
    this.button = button;
    this.root = root;
    this.masterModel = masterModel;

    this.model.selectExportModalShown.onChange(this, function(value){
        if(value) {
            self.showExportModal();
            button.setActive();
        } else {
            if(self.exportModal){
                self.exportModal.remove();
                self.exportModal = null;
                button.setInActive();
            }
        }
    }, 10);

    this.model.forceVersionModalShown.onChange(this, function(value){
        if(value) {
            self.showVersionsModal();
            button.setActive();
        } else {
            if(self.versionModal){
                self.versionModal.remove();
                self.versionModal = null;
                button.setInActive();
            }
        }
    }, 10);

    // if data changes while open
    this.root.data.model3d.onChange(this, function(val){
        if(self.model.selectExportModalShown()){
            self.exportModal.remove();
            self.exportModal = null;
            self.showExportModal();
        }
    });

    if(this.masterModel.wizardMode()){
        self.button.hide();
    } else {
        self.button.show();
    }

    this.masterModel.wizardMode.onChange(this, function(val){
        if(!val){
            self.button.show();
        } else {
            self.button.hide(); // not possible right now
        }
    });

};

module.exports = ExportModelView;

ExportModelView.prototype.showExportModal = function() {
    var self = this;

    if(this.exportModal){
        this.exportModal.remove();
        this.exportModal = null;
    }

    this.exportModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "Export",
            'body': "",
            'modal': true
        }
    });

    this.exportModal.setTheme("dark");
    this.exportModal.deleteButtonArea();

    var packageRow = this.exportModal.addButtonRow("Package", "dark", " ");
    packageRow.appendSubtext("Fusion Electronics library with footprint and 3D package.");

    var pckge = packageRow.addButton("LBR", "dark");
    pckge.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPORT_MODEL_LBR);
        self.stateMachine.handle(cEvent);
    });

    var modelRow = this.exportModal.addButtonRow("3D Model", "dark", " ");
    
    if(this.root.data.model3d() instanceof cio_datamodel.Model3DReference){

        modelRow.appendSubtext("Download the 3D model geometry.");

        var step = modelRow.addButton("STEP", "dark");
        step.$el.on('Cioui:Modal:ModalButton:clicked', function(){
            var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPORT_MODEL_STEP);
            self.stateMachine.handle(cEvent);
        });
        
        // var f3d = modelRow.addButton("F3D", "dark");
        // f3d.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        //     var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPORT_MODEL_F3D);
        //     self.stateMachine.handle(cEvent);
        // });

        var obj = modelRow.addButton("OBJ", "dark");
        obj.$el.on('Cioui:Modal:ModalButton:clicked', function(){
            var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPORT_MODEL_OBJ);
            self.stateMachine.handle(cEvent);
        });
    } else {
        modelRow.addText("No exportable model found.");
    }

    var footprintRow = this.exportModal.addButtonRow("3D Footprint Geometry", "dark", " ");

    if(this.root.data.footprintInstances.size() > 0){
         footprintRow.appendSubtext("For reference in creating a 3D model for this package.");

        var board = footprintRow.addButton("OBJ", "dark");
        board.$el.on('Cioui:Modal:ModalButton:clicked', function(){
            var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.MODEL_BOARD_EXPORT_FOOTPRINT);
            self.stateMachine.handle(cEvent);
        });

    } else {
        footprintRow.addText("No exportable footprint found.");
    }

    this.exportModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPORT_MODEL_CANCEL);
        self.stateMachine.handle(cEvent);
    });

};

ExportModelView.prototype.showVersionsModal = function() {
    var self = this;

    if(this.versionModal){
        this.versionModal.remove();
        this.versionModal = null;
    }

    this.versionModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "Export",
            'body': "You must create a new version in order to download this asset.  Would you like to automatically make a new version and download now?",
            'modal': true
        }
    });

    this.versionModal.setTheme("dark");

    var yes = this.versionModal.addButton("YES");
    yes.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.EXPORT_LBR_MAKEVERSION);
        self.stateMachine.handle(cEvent);
    });

    var no = this.versionModal.addButton("NO", "dark");
    no.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.MAKEVERSION_MODAL_CANCEL);
        self.stateMachine.handle(cEvent);
    });


    this.versionModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.MAKEVERSION_MODAL_CANCEL);
        self.stateMachine.handle(cEvent);
    });
};